var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5273 34.2015L48.9955 31.0605L46.5544 35.8768L43.5273 34.2015Z",
    fill: "#8C303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5011 38.1096V43.8806L42.5543 53.0001H52.6894L26.5011 38.1096Z",
    fill: "url(#paint0_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5011 26.9193V13.3878L36.0321 32.6903L30.8258 35.6683L26.5011 26.9193Z",
    fill: "url(#paint1_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5011 13.406L36.0321 32.6725L41.2207 29.7669L26.5011 0C26.5011 0 26.4009 13.406 26.5011 13.406Z",
    fill: "url(#paint2_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4056 38.2329L52.691 53L41.286 46.5182L45.4056 38.2329Z",
    fill: "url(#paint3_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5005 38.109L53 23.0905L48.9961 31.0589L31.6377 41.0387L26.5005 38.109Z",
    fill: "url(#paint4_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6388 41.0398L37.5327 37.6501L43.8734 41.391L41.3053 46.5514L31.6388 41.0398Z",
    fill: "#2F1014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5333 37.6501L43.53 34.2036L46.5539 35.8767L43.8733 41.391L37.5333 37.6501Z",
    fill: "#5D1F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5011 26.9193V13.3878L29.8532 20.1919L26.5011 26.9193Z",
    fill: "#9B5FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8741 20.2948L26.4979 26.9134L27.4956 28.8261L32.0303 24.5497L29.8741 20.2948Z",
    fill: "url(#paint5_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9961 31.059L31.6377 41.0383L35.9881 43.418L45.2337 38.5374L48.9961 31.059Z",
    fill: "url(#paint6_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47209 34.2015L4.00446 31.0605L6.44558 35.8768L9.47209 34.2015Z",
    fill: "#DA9346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4989 38.1096V43.8806L10.4457 53.0001H0.310608L26.4989 38.1096Z",
    fill: "url(#paint7_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4989 26.9193V13.3878L16.9679 32.6903L22.1742 35.6683L26.4989 26.9193Z",
    fill: "url(#paint8_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4989 13.406L16.9679 32.6725L11.7793 29.7669L26.4989 0C26.4989 0 26.5991 13.406 26.4989 13.406Z",
    fill: "url(#paint9_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59438 38.2329L0.309021 53L11.714 46.5182L7.59438 38.2329Z",
    fill: "url(#paint10_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4995 38.109L0 23.0905L4.00392 31.0589L21.3623 41.0387L26.4995 38.109Z",
    fill: "url(#paint11_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3612 41.0398L15.4667 37.6501L9.12665 41.391L11.6947 46.5514L21.3612 41.0398Z",
    fill: "#A33844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4667 37.6501L9.46993 34.2036L6.44611 35.8767L9.12663 41.391L15.4667 37.6501Z",
    fill: "#D14A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4989 26.9193V13.3878L23.1468 20.1919L26.4989 26.9193Z",
    fill: "#9B5FE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1259 20.2948L26.5022 26.9134L25.5044 28.8261L20.9697 24.5497L23.1259 20.2948Z",
    fill: "url(#paint12_linear_51_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00391 31.059L21.3623 41.0383L17.0113 43.418L7.76628 38.5374L4.00391 31.059Z",
    fill: "url(#paint13_linear_51_104)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_104",
    x1: 26.5011,
    y1: 45.5548,
    x2: 52.6894,
    y2: 45.5548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#492771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D102D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_104",
    x1: 28.3178,
    y1: 23.929,
    x2: 33.8631,
    y2: 33.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#743EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_104",
    x1: 32.2092,
    y1: 18.159,
    x2: 39.112,
    y2: 31.4834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_104",
    x1: 53.3256,
    y1: 52.3648,
    x2: 42.2956,
    y2: 41.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_104",
    x1: 40.1292,
    y1: 31.2438,
    x2: 42.1088,
    y2: 34.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A33844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_104",
    x1: 29.5013,
    y1: 25.022,
    x2: 27.5718,
    y2: 23.9332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_104",
    x1: 42.3084,
    y1: 39.5013,
    x2: 40.539,
    y2: 36.4401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_104",
    x1: 26.4989,
    y1: 45.5548,
    x2: 0.310072,
    y2: 45.5548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_104",
    x1: 24.6822,
    y1: 23.929,
    x2: 19.1369,
    y2: 33.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9B5FE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66369E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_51_104",
    x1: 20.7908,
    y1: 18.159,
    x2: 13.888,
    y2: 31.4834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_51_104",
    x1: -0.32563,
    y1: 52.3648,
    x2: 10.7039,
    y2: 41.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_51_104",
    x1: 0.0283851,
    y1: 24.2221,
    x2: 24.3952,
    y2: 40.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4CEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E49844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA3F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_51_104",
    x1: 23.4982,
    y1: 25.022,
    x2: 25.4276,
    y2: 23.9332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_51_104",
    x1: 10.691,
    y1: 39.5013,
    x2: 12.4605,
    y2: 36.4401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logoMark.18944bc9ba32760572cc5e78d13adda2.svg";
export { ForwardRef as ReactComponent };